import styled from "styled-components/macro";

export const CfcConfirmationLayout = styled.section`
  max-width: 920px;
  margin: 0 auto;
`;

export const CfcConfirmationMessage = styled.p`
  margin: 0 0 24px;
  font-family: bold;
  font-size: 18px;
  line-height: 28px;
  color: ${({ theme }) => theme.greyDark};
`;

export const CfcConfirmationFieldsGrid = styled.dl`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px 24px;
  margin-bottom: 24px;

  @media (max-width: 800px) {
    grid-template-columns: 1fr;
  }
`;

export const CfcConfirmationField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

export const CfcConfirmationFieldLabel = styled.dt`
  font-family: light;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.greyMedium};
`;

export const CfcConfirmationFieldValue = styled.dd`
  margin: 0;
  font-family: light;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.black};
`;

export const CfcConfirmationInfoBanner = styled.div`
  background-color: ${({ theme }) => theme.blueSubtle};
  border: 1px solid ${({ theme }) => theme.blueLight};
  border-radius: 6px;
  padding: 16px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${({ theme }) => theme.blueDark};
  font-family: light;
  font-size: 16px;
  line-height: 24px;

  strong {
    font-family: bold;
    font-weight: 700;
  }
`;

export const CfcConfirmationGraphicWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 24px;

  svg {
    max-width: 100%;
    height: auto;
  }
`;
